import React, {
  useEffect,
  Fragment,
  useCallback,
  useState,
  useRef,
} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../components/Header";
import { Box, Button, Grid, MenuItem } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Select from "react-dropdown-select";
import { BiArrowBack } from "react-icons/bi";
import { BiChevronUp, BiChevronDown } from "react-icons/bi";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import { Autocomplete, Pagination } from "@material-ui/lab";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Setting from "../components/Setting";
import Typography from "@material-ui/core/Typography";
import { BiXCircle, BiInfoCircle } from "react-icons/bi";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { Link } from "react-router-dom";
import { apiAxios } from "../Util/ApiAxios";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PatientStatus from "../components/PatientStatus";
import Loader from "react-loader-spinner";
import { getAge } from "../Util/validations";
// import PatientStatus from "../components/PatientStatus";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function PatientFilterSearch(props, { options }) {
  const classes = useStyles();

  const [selectedValue, setSelectedValue] = React.useState("patient");
  const [providerList, setProviderList] = useState([]);
  const [providerListOption, setProviderListOption] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("");

  const [programList, setProgramList] = useState([]);
  const [programListOption, setProgramListOption] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState("");

  const [patientList, setPatientList] = useState([]);

  const [searchVal, setSearchVal] = useState("");
  const [checked, setChecked] = React.useState(false);

  const [message, setMessage] = useState("");

  const [flag, setFlag] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const currentPageRef = useRef(1);
  const [currentReportPage, setCurrentReportPage] = useState(1);
  const [totalReportPages, setTotalReportPages] = useState(1);

  const [patientID, setPatientID] = React.useState("");
  const [patientReport, setPatientReport] = React.useState("");
  const [tablemessage, setTableMessage] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [healthcoach, setHealthcoach] = useState(false);
  const [coachError, setCoachError] = useState("");
  const [coachData, setCoachData] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [agentId, setAgentId] = React.useState("");
  const [pdID, setPdID] = React.useState("");
  const [cpatpId, setCpatpId] = React.useState("");
  const [agentData, setAgentData] = React.useState([]);
  const [selectedAgent, setSelectedAgent] = React.useState("");
  const [agentListOption, setAgentListOption] = React.useState([]);

  let domain_name = "https://dhct-new-dev-media.s3.us-east-1.amazonaws.com/";

  useEffect(() => {
    getProviderList();
    getProgramList();
    getPatientList();

    if (localStorage.getItem("dhct_tab")) {
      localStorage.removeItem("dhct_tab");
      localStorage.removeItem("dhct_panel");
    }

    if (localStorage.getItem("dhct_engagement_timer")) {
      localStorage.removeItem("dhct_engagement_timer");
    }
  }, []);

  useEffect(() => {
    if (providerList) {
      var ob_arr = [];
      //console.log("user types = ", userTypes);
      for (var i = 0; i < providerList.length; i++) {
        let value = providerList[i].id;
        let label =
          providerList[i].first_name + " " + providerList[i].last_name;
        let ob = {
          label: label,
          value: value,
        };
        //console.log("ob types = ", ob);
        ob_arr.push(ob);
      }
      setProviderListOption(ob_arr);
      setSelectedProvider(ob_arr[0]);
    }
  }, [providerList]);

  useEffect(() => {
    if (agentData) {
      var ob_arr = [];
      //console.log("user types = ", userTypes);
      for (var i = 0; i < agentData.length; i++) {
        let value = agentData[i].id;
        let label = agentData[i].first_name + " " + agentData[i].last_name;
        let ob = {
          label: label,
          value: value,
        };
        //console.log("ob types = ", ob);
        ob_arr.push(ob);
      }
      setAgentListOption(ob_arr);
      setSelectedAgent(ob_arr[0]);
    }
  }, [agentData]);

  const handleChangeChecked = (event) => {
    const newChecked = event.target.checked;
    setChecked(newChecked);
    getPatientList({ assignedToMe: newChecked });
  };

  useEffect(() => {
    if (programList) {
      var ob_arr = [];
      //console.log("user types = ", userTypes);
      for (var i = 0; i < programList.length; i++) {
        let value = programList[i].id;
        let label = programList[i].program_name;
        let id = programList[i].template_id;
        let ob = {
          label: label,
          value: value,
          template_id: id,
        };
        //  console.log("ob types = ", ob);
        ob_arr.push(ob);
      }
      setProgramListOption(ob_arr);
      setSelectedProgram(ob_arr[0]);
    }
  }, [programList]);

  function openPatProgram(data) {
    props.history.push({
      pathname: "/patient-information",
      state: {
        patientInfo: data,
        providerList: providerListOption,
        programList: programListOption,
      },
    });
  }

  function getProviderList() {
    let jwt = JSON.parse(localStorage.getItem("dhct_JWT"));

    let data = {
      // table_config_rows_per_page: "25",
      // table_config_page_no: "1",
      search_value: "",
      cutid: "",
      user_master_type_id: "",
      client_id: jwt.client_id,
      is_provider: 1,
      pagination: false,
    };

    apiAxios
      .post("/client/clientuserlist", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("dhct_Token"),
        },
      })
      .then((response) => {
        console.log("response --> ", response);
        if (response.data.statusCode == 200) {
          setProviderList(response.data.data);
        } else {
          // toast.error(response.data.message, {
          //     position: "bottom-center",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     });
        }
      })
      .catch((error) => {
        console.log(error);

        // toast.error(error.message, {
        //     position: "bottom-center",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     });

        localStorage.removeItem("dhct_Refresh_Token");
        localStorage.removeItem("dhct_Token");
        window.location.href = "/";
      });
  }
  // delete patient
  // const deletePatient = (id) => {
  //   let data = {
  //     patient_program_id: id,
  //   };

  //   apiAxios
  //     .post("/program/delete-client-patient-programs", data, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: localStorage.getItem("dhct_Token"),
  //       },
  //     })
  //     .then((response) => {
  //       console.log("delete response --> ", response);
  //       if (response.data.status == 200) {
  //         toast.success(response.data.message, {
  //           position: "bottom-center",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //         });

  //         const timer = setTimeout(() => {
  //           window.location.href = "/patient-search";
  //         }, 2000);
  //       } else {
  //         toast.error(response.data.message, {
  //           position: "bottom-center",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);

  //       toast.error(error.message, {
  //         position: "bottom-center",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });

  //       localStorage.removeItem("dhct_Refresh_Token");
  //       localStorage.removeItem("dhct_Token");
  //       window.location.href = "/";
  //     });
  // };

  // delete modal

  // const deleteModal = (id) => {
  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       return (
  //         <div className="custom-ui">
  //           <h1>Are you sure?</h1>
  //           <p>You want to delete this record?</p>
  //           <button
  //             className={classes.modalNoBtn}
  //             style={{
  //               border: "2px solid #0f3d6e",
  //               cursor: "pointer",
  //               width: "auto",
  //             }}
  //             onClick={onClose}
  //           >
  //             No
  //           </button>
  //           <button
  //             className={classes.loginbtn}
  //             style={{ marginLeft: "10px", cursor: "pointer", width: "auto" }}
  //             onClick={() => {
  //               deletePatient(id);
  //               onClose();
  //             }}
  //           >
  //             Yes, Delete
  //           </button>
  //         </div>
  //       );
  //     },
  //   });
  // };

  // download finalize pdf
  // const downloadPDF = (id) => {
  //   let data = {
  //     pdf_type: 0,
  //     finalization_id: id,
  //   };

  //   apiAxios
  //     .post("/report/create-patient-report", data, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: localStorage.getItem("dhct_Token"),
  //       },
  //     })
  //     .then((response) => {
  //       console.log("fin response --> ", response);
  //       if (response.data.statusCode == 200) {
  //         let url =
  //           response.data.domain_name +
  //           response.data.s3_finalization_pdf_report_url;
  //         console.log(url);
  //         window.location.href = url;
  //       } else {
  //         toast.error(response.data.message, {
  //           position: "bottom-center",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);

  //       toast.error(error.message, {
  //         position: "bottom-center",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });

  //       localStorage.removeItem("dhct_Refresh_Token");
  //       localStorage.removeItem("dhct_Token");
  //       window.location.href = "/";
  //     });
  // };

  function getProgramList() {
    let data = {
      table_config_rows_per_page: "50",
      table_config_page_no: "1",
      program_id: "",
      provider_id: "",
      client_id: "",
      search_value: "",
      status: "1",
      is_unique: "1",
    };

    apiAxios
      .post("/client/client-provider-program-list", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("dhct_Token"),
        },
      })
      .then((response) => {
        console.log("response --> ", response);
        if (response.data.statusCode == 200) {
          setProgramList(response.data.data);
        } else {
          // toast.error(response.data.message, {
          //     position: "bottom-center",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     });
        }
      })
      .catch((error) => {
        console.log(error);

        // toast.error(error.message, {
        //     position: "bottom-center",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     });

        localStorage.removeItem("dhct_Refresh_Token");
        localStorage.removeItem("dhct_Token");
        window.location.href = "/";
      });
  }

  function submitSearch() {
    getPatientList();
    setFlag(true);
  }

  function resetFilter() {
    window.location.href = "/patient-list";
  }

  // function backButton() {
  //   window.location.href = "/dashboard";
  // }

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleKeyPress = (e) => {
    console.log(e);
    if (e.key === "Enter") {
      submitSearch();
    }
  };

  // patient report download modal

  const [openView, setOpenView] = React.useState(false);

  const handleClickOpenView = (data) => {
    console.log(data.id);

    setOpenView(true);
    setPatientID(data.pd_id);
    let patientId = data.pd_id;
    getPatientReport(patientId);

    // if(patientId){
    //   getPatientReport()
    // }else {

    // }

    //  getPatientReport(patientId)
  };

  const handleCloseView = () => {
    // setPatientID("")
    setPatientID("");
    setPatientReport("");
    setTotalReportPages(1);
    setOpenView(false);
  };
  // patient report download

  const getPatientReport = useCallback(
    async (
      id,
      { table_config_rows_per_page = "15", table_config_page_no = "1" } = {}
    ) => {
      setCurrentPage(parseInt(table_config_page_no));

      console.log(patientID);

      setPatientID(id);

      let data = {
        table_config_rows_per_page: table_config_rows_per_page,
        table_config_page_no: table_config_page_no,
        pd_id: id ? id : patientID,
      };

      setTableMessage("Loading...");

      apiAxios
        .post("/report/patient-history-report", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("patient list data --> ", response);
          if (response.data.statusCode == 200) {
            setPatientReport(response.data.data);
            setTotalReportPages(response.data.total_pages);

            if (response.data.data.length == 0) {
              setTableMessage("No Data Found");
            }
          } else {
            toast.error(response.data.message, {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          console.log(error);

          toast.error("Something Went Wrong!", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    }
  );

  const closeModal = (e) => {
    e?.stopPropagation();
    setModalOpen(false);
    setHealthcoach("");
    setPdID("");
    setAgentId("");
  };

  useEffect(() => {
    let data = {
      table_config_page_no: "1",
      cutid: "",
      search_value: "",
      table_config_rows_per_page: "499",
      user_master_type_id: "",
      is_provider: false,
      is_nurse: true,
      non_doc_profile: true,
    };

    apiAxios
      .post("/client/clientuserlist", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("dhct_Token"),
        },
      })
      .then((response) => {
        if (response.data.statusCode == 200) {
          setCoachData(response.data.health_coach_data);
          const nurseList = response.data.nurse_data || [];
          setAgentData(nurseList);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getPatientList = useCallback(
    async ({
      table_config_rows_per_page = "15",
      table_config_page_no = "1",
      assignedToMe = checked,
    } = {}) => {
      setCurrentPage(parseInt(table_config_page_no));

      setPatientList([]);
      setMessage("Loading...");

      const isDoctor = JSON.parse(
        localStorage.getItem("dhct_JWT")
      ).permission.includes(8);

      let data = {
        table_config_page_no: table_config_page_no,
        pd_id: "",
        client_user_id: selectedProvider?.[0]?.value || "",
        filter_id: selectedAgent?.[0]?.value || "",
        search_value: searchVal ? searchVal : "",
        status: "",
        assigned_to_me: assignedToMe ? "1" : "0",
        client_provider_program_id: selectedProgram[0]
          ? selectedProgram[0].value
          : "",
        table_config_rows_per_page: table_config_rows_per_page,
        provider_only: true,
        is_filter: "1",
      };

      apiAxios
        .post("/patient/client-patient-program-list", data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("response --> ", response);
          if (response.data.statusCode == 200) {
            setPatientList(response.data.data);
            setMessage("");
            setTotalPages(response.data.total_pages);
          } else if (response.data.statusCode == 502) {
            setMessage("No Data Found");
          } else {
            // toast.error(response.data.message, {
            //     position: "bottom-center",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     });

            setMessage(response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);

          // toast.error(error.message, {
          //     position: "bottom-center",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     });

          localStorage.removeItem("dhct_Refresh_Token");
          localStorage.removeItem("dhct_Token");
          // window.location.href = "/";
        });
    }
  );

  const patientNames = patientList.map((pd) => `${pd.patient_first_name}`);

  useEffect(() => {
    const timer = setTimeout(() => {
      getPatientList();
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [searchVal]);

  const addCoach = () => {
    let isvalid = true;
    if (healthcoach == "") {
      setCoachError(true);
      isvalid = false;
    } else {
      setCoachError(false);
    }

    if (isvalid) {
      setShowLoader(true);
      let dataActive = {
        patient_program_id: cpatpId,
        patient_programe_care_team_assoc: agentId ? agentId : "",
        patient_programe_health_coach: healthcoach ? healthcoach : "",
        status: 1,
        pd_id: pdID,
      };
      console.log(dataActive);
      apiAxios
        .post("/client/update-client-patient-program", dataActive, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("dhct_Token"),
          },
        })
        .then((response) => {
          console.log("res", response.data);
          setShowLoader(false);

          if (response.data.statusCode == 200) {
            toast.success(response.data.message, {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setModalOpen(false);
            setHealthcoach("");
            setPdID("");
            setAgentId("");
            window.location.reload();
          } else {
            toast.error(response.data.message, {
              position: "bottom-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setModalOpen(false);
            setHealthcoach("");
            setPdID("");
            setAgentId("");
          }
        })
        .catch((error) => {
          setShowLoader(false);
          setModalOpen(false);
          setHealthcoach("");
          setPdID("");
          setAgentId("");
          console.log(error);
          toast.error(error.message, {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
    }
  };

  // function formatPhoneNumber(value) {
  //   // if input value is falsy eg if the user deletes the input, then just return
  //   if (!value) return value;

  //   // clean the input for any non-digit values.
  //   const phoneNumber = value.replace(/[^\d]/g, "");

  //   // phoneNumberLength is used to know when to apply our formatting for the phone number
  //   const phoneNumberLength = phoneNumber.length;

  //   // we need to return the value with no formatting if its less then four digits
  //   // this is to avoid weird behavior that occurs if you  format the area code to early

  //   if (phoneNumberLength < 4) return phoneNumber;

  //   // if phoneNumberLength is greater than 4 and less the 7 we start to return
  //   // the formatted number
  //   if (phoneNumberLength < 7) {
  //     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  //   }

  //   // finally, if the phoneNumberLength is greater then seven, we add the last
  //   // bit of formatting and return it.
  //   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
  //     3,
  //     6
  //   )}-${phoneNumber.slice(6, 10)}`;
  // }

  return (
    <div>
      {/* <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}

      <Header />
      <Box className={classes.pagecontent}>
        <Box className={classes.leftcol}>
          <Box className={classes.leftnav} style={{ marginTop: "40px" }}>
            {localStorage.getItem("dhct_JWT") ? <PatientStatus /> : <></>}
          </Box>
        </Box>
        <Box className={classes.Rightcol}>
          {/* <Box className={classes.pageTop}>
          <Button onClick={backButton} className={classes.Backbtn}>
            <BiArrowBack className={classes.backarrow} /> Back to previous
          </Button>
        </Box> */}

          <br />

          <Box className={classes.Searchresult}>
            <Box className={classes.Topfilter}>
              {JSON.parse(localStorage.getItem("dhct_JWT")).permission.includes(
                8
              ) ? (
                <Box className={classes.FilterCol} style={{ marginRight: 15 }}>
                  <label>Doctor Filter</label>
                  <Select
                    // options={[...providerListOption].sort((a, b) =>
                    //   a.label.localeCompare(b.label)
                    // )}
                    options={providerListOption}
                    value={selectedProvider}
                    onChange={setSelectedProvider}
                    placeholder="Select Doctor"
                    className={classes.select}
                    style={{ width: "100%" }}
                  />
                </Box>
              ) : (
                <Box className={classes.FilterCol} style={{ marginRight: 15 }}>
                  <label>Nurse Filter</label>
                  <Select
                    // options={[...agentListOption].sort((a, b) =>
                    //   a.label.localeCompare(b.label)
                    // )}
                    options={agentListOption}
                    value={selectedAgent}
                    onChange={setSelectedAgent}
                    placeholder="Select Nurse"
                    className={classes.select}
                    style={{ width: "100%" }}
                  />
                </Box>
              )}

              <Box className={classes.FilterCol2} style={{ marginRight: 15 }}>
                <label>Program Filter</label>
                <Select
                  options={programListOption}
                  value={selectedProgram}
                  onChange={setSelectedProgram}
                  placeholder="Select Program"
                  className={classes.select}
                  style={{ width: "100%" }}
                />
              </Box>
              <Box className={classes.FilterSearchCol}>
                <label>Patient Search</label>
                <Autocomplete
                  freeSolo
                  options={
                    searchVal.length > 0
                      ? [...patientNames].sort((a, b) => a.localeCompare(b))
                      : []
                  }
                  inputValue={searchVal}
                  className={classes.input}
                  onInputChange={(event, newInputValue) => {
                    setSearchVal(newInputValue);
                  }}
                  onKeyDown={handleKeyPress}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        style: {
                          ...(params.inputProps?.style ?? {}),
                          paddingLeft: "1rem",
                          height: "36px",
                        },
                      }}
                      placeholder="Patient Search"
                      type="text"
                    />
                  )}
                />
              </Box>
              <Button className={classes.Searchbtn} onClick={submitSearch}>
                Search
              </Button>
              <FormGroup style={{ margin: "30px 0 0 15px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checked}
                      onChange={handleChangeChecked}
                    />
                  }
                  label="Assigned to me only"
                />
              </FormGroup>
              <p
                style={{
                  color: "blue",
                  cursor: "pointer",
                  margin: "40px 0 0 0",
                }}
                onClick={resetFilter}
              >
                Reset
              </p>
            </Box>
            {/* <h3 className={classes.Toptext} style={{ textAlign: "left" }}>
              Patients w/ 10mins or more with no finalize List
            </h3> */}

            <Box>
              {searchVal && flag ? (
                <h4>Search Results for ‘{searchVal}’</h4>
              ) : (
                <></>
              )}
            </Box>
            <Box className={classes.PatientListTable}>
              <Box className={classes.throw}>
                <Box className={classes.firstname}>First Name</Box>
                <Box className={classes.lastname}>Last Name</Box>
                <Box className={classes.phone}>Phone</Box>
                <Box className={classes.dob}>Age</Box>

                <Box className={classes.hrpmID}>HRPM ID</Box>
                {/* <Box className={classes.emrID}>EMR ID</Box> */}
                <Box className={classes.status}>Status</Box>
                {/* <Box className={classes.date}>Date Loaded</Box> */}
                <Box className={classes.agentID}>Nurse</Box>
                <Box className={classes.provider}>Doctor</Box>
                <Box className={classes.finaldate}>Health Coach</Box>
                {/* <Box className={classes.plan}>Care Plan</Box> */}
                {/* <Box className={classes.actionHead}>Action</Box> */}
                <Box className={classes.program}>Program</Box>
              </Box>
              {patientList.length > 0 ? (
                <>
                  {patientList.map((each) => (
                    <Box className={classes.tdrow}>
                      <Box className={classes.firstname}>
                        {each.patient_first_name}
                      </Box>
                      <Box className={classes.lastname}>
                        {each.patient_last_name}
                      </Box>
                      <Box className={classes.phone}>
                        {each.patient_primary_phone}
                      </Box>
                      <Box className={classes.dob}>
                        {getAge(each.patient_dob)} years
                      </Box>
                      <Box className={classes.hrpmID}>{each.hrpm_id}</Box>
                      {/* <Box className={classes.emrID}>{each.emr_id}</Box> */}
                      <Box className={classes.status}>
                        {each.status == "2"
                          ? "Deleted"
                          : each.status == "1"
                          ? "Active"
                          : "Inactive"}
                      </Box>
                      {/* <Box className={classes.date}>
                        {each.patient_load_date ? each.patient_load_date : "--"}
                      </Box> */}
                      <Box className={classes.agentID}>{each.agent_id}</Box>
                      <Box className={classes.provider}>
                        {each.provider_first_name +
                          " " +
                          each.provider_last_name}
                      </Box>
                      <Box className={classes.finaldate}>
                        {each.health_coach ? (
                          each.health_coach
                        ) : JSON.parse(
                            localStorage.getItem("dhct_JWT")
                          ).permission.includes(8) ? (
                          <Box
                            onClick={() => {
                              setModalOpen(true);
                              setAgentId(each.agent_id);
                              setPdID(each.pd_id);
                              setCpatpId(each.cpatp_id);
                            }}
                          >
                            <b
                              style={{
                                color: "#88b3eb",
                                cursor: "pointer",
                              }}
                            >
                              Add Healthcoach
                            </b>
                          </Box>
                        ) : (
                          <span>No Healthcoach Assigned</span>
                        )}
                      </Box>
                      {/* {each.finalized_id ? (
                      <Box className={classes.plan}>
                        <Button
                          className={classes.planbtn}
                          onClick={() => downloadPDF(each.finalized_id)}
                        >
                          <b>Download PDF</b>
                        </Button>
                      </Box>
                    ) : (
                      <Box className={classes.plan}>
                        <Button
                          className={classes.planbtn}
                          style={{ opacity: 0.3, pointerEvents: "none" }}
                        >
                          <b>Download PDF</b>
                        </Button>
                      </Box>
                    )} */}
                      {/* <Box className={classes.action}>
                      <Button
                        className={classes.planbtn}
                        onClick={() => deleteModal(each.cpatp_id)}
                      >
                        <b>Delete</b>
                      </Button>
                      <Button
                        className={classes.planbtn}
                        style={{ marginTop: "2px" }}
                        onClick={() => {
                          handleClickOpenView(each);
                        }}
                      >
                        <b>Report</b>
                      </Button>
                    </Box> */}
                      <Box
                        className={classes.program}
                        onClick={() => openPatProgram(each)}
                      >
                        {/* <b style={{ color: "#88b3eb" }}>{each.program_abbrev}</b> */}
                        <b style={{ color: "#88b3eb" }}>View</b>
                      </Box>
                    </Box>
                  ))}
                </>
              ) : (
                <Box style={{ marginTop: "30px", textAlign: "center" }}>
                  {message}
                </Box>
              )}
            </Box>
          </Box>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "right",
              justifyContent: "right",
            }}
          >
            <Pagination
              count={totalPages}
              color="primary"
              page={currentPage}
              onChange={(event, pageNumber) =>
                getPatientList({
                  table_config_page_no: `${pageNumber}`,
                })
              }
            />
          </div>
        </Box>
      </Box>
      {/* Health-coach  */}
      <Dialog
        className={classes.modal}
        onClose={closeModal}
        aria-labelledby="customized-dialog-title"
        open={isModalOpen}
      >
        <DialogContent>
          <Typography
            variant="h3"
            style={{
              fontSize: 18,
              fontFamily: "Poppins",
              fontWeight: "600",
              marginRight: "60px",
            }}
          >
            Choose Your Healthcoach
          </Typography>
          <Box>
            <Button onClick={closeModal} className={classes.Modalclose}>
              <BiXCircle
                size="30"
                color="#0f3d6e"
                className={classes.closeicon}
              />
            </Button>
          </Box>
          <DialogContentText>
            <Box>
              <FormControl
                fullWidth
                error={!!coachError}
                style={{ marginTop: "26px" }}
              >
                <Typography variant="subtitle1">
                  Select Your Coach<span style={{ color: "#ff0000" }}>*</span>
                </Typography>
                <Box className={classes.Formcol}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={coachData}
                    getOptionLabel={(option) =>
                      option?.first_name + " " + option?.last_name
                    }
                    style={{ width: "100%" }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Health Coach"
                        disabled={true}
                      />
                    )}
                    placeholder="Select "
                    getOptionSelected={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(e, v) => {
                      console.log("onchangeA_value" + v);
                      setHealthcoach(v ? v.id : "");
                      if (
                        e.target.value === undefined ||
                        e.target.value === null
                      ) {
                        setHealthcoach("");
                      }
                    }}
                  />
                </Box>
                {coachError ? (
                  <p
                    style={{
                      color: "#dc3545",
                      fontSize: ".875em",
                      marginTop: "0.25rem",
                      width: "100%",
                      textAlign: "right",
                    }}
                  >
                    Please select your Healthcoach.
                  </p>
                ) : (
                  <></>
                )}
              </FormControl>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {showLoader ? (
            <Loader
              type="ThreeDots"
              color="#000000"
              height={50}
              width={50}
              timeout={0}
              marginRight={20}
            />
          ) : (
            <Button
              size="large"
              style={{ color: "#fff" }}
              className={classes.chartbtn}
              onClick={addCoach}
            >
              Add
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* Excel List */}
      <Dialog
        className={classes.downloadModal}
        open={openView}
        disableEnforceFocus={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseView}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent className={classes.ccmmodal}>
          <Box className={classes.ModalTop}>
            {/* <Typography variant="h5" className={classes.TopHeading}>
              Excel List 
            </Typography> */}
            <h2
              className={classes.TopHeading}
              style={{
                fontFamily: "poppins",
                fontSize: 20,
                color: "#000",
                marginTop: 0,
                marginBottom: 30,
              }}
            >
              Patient Report List
            </h2>
            <Button onClick={handleCloseView} className={classes.closebtn}>
              <BiXCircle className={classes.closeicon} />
            </Button>
          </Box>

          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box className={classes.Throw1}>
                  <Box className={classes.Thcol5}>Patient Name</Box>
                  <Box className={classes.Thcol6}>Doctor Name</Box>
                  <Box className={classes.Thcol8}>Finalized Date</Box>
                  <Box className={classes.Thcol11}>Finalized Total Time</Box>
                  <Box className={classes.Thcol12}>Download</Box>
                </Box>

                {patientReport.length > 0 ? (
                  <>
                    {patientReport.map((each) => (
                      <Box className={classes.Tdrow1}>
                        <Box className={classes.Tdcol5}>
                          {each.patient_name}
                        </Box>
                        <Box className={classes.Tdcol6}>
                          {each.provider_name}
                        </Box>
                        <Box className={classes.Tdcol8}>
                          {each.finalized_datetime
                            ? moment(each.finalized_datetime).format(
                                "YYYY-MM-DD HH:mm a"
                              )
                            : "--"}
                        </Box>
                        <Box className={classes.Tdcol11}>
                          {each.finalized_total_minutes
                            ? moment(each.finalized_total_minutes).format(
                                "HH:mm"
                              )
                            : "--"}
                        </Box>

                        <Box className={classes.Tdcol12}>
                          {/* <Button className={classes.EditBtn} onClick={() => handleClickOpenView(each,2)}>Edit</Button> */}
                          <Button
                            className={classes.ActionBtn}
                            onClick={() => {
                              window.location =
                                domain_name + each.s3_finalization_pdf_url;
                            }}
                          >
                            Download
                          </Button>
                        </Box>
                      </Box>
                    ))}
                  </>
                ) : (
                  <Box className={classes.Tdrow1}>
                    <Box
                      className={classes.Tdcol12}
                      style={{
                        width: "100%",
                        textAlign: "center",
                        color: "#dfdfdf",
                      }}
                    >
                      No Data Available
                    </Box>
                  </Box>
                )}

                <br />
                <Box
                  style={{
                    width: "100%",
                    display: "flex",
                    overflow: "hidden",
                    justifyContent: "flex-end",
                  }}
                >
                  <Pagination
                    count={totalReportPages}
                    color="primary"
                    page={currentReportPage}
                    onChange={(event, pageNumber) =>
                      getPatientReport(patientID, {
                        table_config_page_no: `${pageNumber}`,
                      })
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.modalbtn}>
          <FormGroup aria-label="position" row></FormGroup>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default PatientFilterSearch;
const useStyles = makeStyles(() => ({
  // pagecontent: {
  //   width: "94%",
  //   background: "linear-gradient(to bottom, #0f3d6e05, #ffffff00)",
  //   padding: "20px 3%",
  //   display: "flex",
  //   flexDirection: "column",
  //   "& a": {
  //     textDecoration: "none",
  //   },
  // },
  pagecontent: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    "& a": {
      textDecoration: "none",
    },
  },
  Rightcol: {
    width: "75%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "@media only screen and (max-width: 820px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "@media only screen and (max-width: 768px)": {
      width: "96%",
      padding: "0 2%",
      marginTop: 30,
    },
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
  },

  leftcol: {
    width: "15%",
    padding: "20px 3%",
    minHeight: "800px",
    background: "linear-gradient(-45deg, #114ebd, #0f3d6e)",
    position: "relative",
    "@media only screen and (max-width: 820px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "@media only screen and (max-width: 768px)": {
      position: "absolute",
      background: "none",
      width: "96%",
      padding: "30px 2%",
    },
    "& ul": {
      listStyle: "none",
      margin: "0px",
      padding: "0px",
      "& li": {
        color: "#1C295D",
        fontSize: "12px",
        fontWeight: "500",
      },
      "& li button": {
        background: "#f1f1f1",
        width: "150px",
        height: "55px",
        margin: "8px 0",
        textAlign: "center",
        color: "#0f3d6e",
        borderRadius: "10px",
        fontSize: "18px",
        "&:hover": {
          background: "#0f3d6e",
        },
      },
    },
  },
  leftnav: {
    position: "absolute",
    top: "15px",
    bottom: "15px",
    left: "40px",
    right: "40px",
    "@media only screen and (max-width: 1200px)": {
      left: "20px",
      right: "20px",
    },
  },
  bottomnav: {
    position: "absolute",
    bottom: "0px",
    left: "0px",
  },
  FilterCol: {
    width: "15.5%",
    "@media only screen and (max-width: 1200px)": {
      width: "24%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "47.5%",
      marginBottom: 10,
    },
    "@media only screen and (max-width: 768px)": {
      width: "47.5%",
      marginBottom: 10,
    },
  },
  FilterCol2: {
    width: "20%",
    "@media only screen and (max-width: 1200px)": {
      width: "32%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "47.5%",
      marginBottom: 10,
    },
    "@media only screen and (max-width: 768px)": {
      width: "47.5%",
      marginBottom: 10,
    },
  },
  FilterSearchCol: {
    width: "30%",
    "@media only screen and (max-width: 1200px)": {
      width: "30.5%",
    },
    "@media only screen and (max-width: 820px)": {
      width: "45.5%",
    },
    "@media only screen and (max-width: 768px)": {
      width: "45.5%",
    },
  },
  chartbtn: {
    background: "#0f3d6e",
    borderRadius: "10px",
    padding: "0 20px",
    height: "40px",
    color: "#fff",
    textTransform: "capitalize",
    fontSize: "14px",
    cursor: "pointer",
    "&:hover": {
      background: "#333",
    },
  },
  loginbtn: {
    background: "#0f3d6e",
    padding: "0 40px",
    width: "120px",
    height: "40px",
    borderRadius: "10px",
    color: "#fff",
    marginTop: "20px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#333",
    },
  },
  ActionBtn: {
    borderRadius: 10,
    textTransform: "capitalize",
    background: "#0A70E8",
    color: "#fff",
    "&:hover": {
      background: "rgba(0,0,0,0.8)",
    },
  },
  modalNoBtn: {
    background: "#0f3d6e",
    padding: "0 40px",
    width: "120px",
    height: "40px",
    borderRadius: "10px",
    color: "#fff",
    marginTop: "20px",
    textTransform: "capitalize",
    "&:hover": {
      background: "#333",
    },
  },
  PatientListTable: {
    width: "100%",
    overflowX: "auto",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        overflowX: "auto",
      },
  },
  throw: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    borderBottom: "2px #E3E5E5 solid",
    fontSize: "14px",
    color: "#fff",
    paddingBottom: "5px",
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    // padding: 6,
    padding: "10px 10px",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  tdrow: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px #E3E5E5 solid",
    fontSize: "14px",
    width: "100%",
    // padding: "10px 0",
    padding: "10px 10px",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        width: 1366,
      },
  },
  providerbtn: {
    display: "flex",
    cursor: "pointer",
    "& span": {
      display: "flex",
      flexDirection: "column",
      width: "20px",
      marginRight: "10px",
      "& button": {
        background: "none",
        border: "none",
        height: "10px",
        cursor: "pointer",
      },
    },
  },
  provider: {
    width: "10%",
    textAlign: "center",
    paddingRight: 5,
    paddingLeft: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  firstname: {
    width: "10%",
    textAlign: "left",
    wordWrap: "break-word",
    overflow: "auto",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  lastname: {
    width: "10%",
    textAlign: "left",
    wordWrap: "break-word",
    overflow: "auto",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  dob: {
    width: "5%",
    textAlign: "center",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  // emrID:{
  //     width:'5%',
  //     textAlign:'left'
  // },
  hrpmID: {
    width: "5%",
    textAlign: "right",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  emrID: {
    width: "11%",
    textAlign: "center",
    wordWrap: "break-word",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  status: {
    width: "10%",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
    textAlign: "center",
  },
  phone: {
    width: "13%",
    textAlign: "center",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  program: {
    width: "10%",
    textAlign: "center",
    cursor: "pointer",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  date: {
    width: "12%",
    textAlign: "center",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  agentID: {
    width: "10%",
    textAlign: "center",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  finaldate: {
    width: "15%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  plan: {
    width: "15%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  actionHead: {
    width: "10%",
    textAlign: "left",
    paddingRight: 5,
    fontFamily: "poppins",
    fontSize: 14,
  },
  action: {
    width: "10%",
    textAlign: "left",
    overflow: "scroll",
    fontFamily: "poppins",
    fontSize: 14,
  },
  Toptext: {
    fontSize: 20,
    marginTop: 0,
    fontWeight: "600",
    fontFamily: "Poppins",
    color: "#121212",
  },
  planbtn: {
    fontSize: "13px",
    color: "#fff",
    background: "#0f3d6e",
    textTransform: "capitalize",
    padding: "0px 5px",
    "&:hover": {
      background: "#333",
    },
  },
  pageTop: {
    textAlign: "left",
    "& button": {
      padding: "0px 5px",
      background: "none",
      color: "#bfc4cb",
      fontSize: "14px",
      textTransform: "capitalize",
      fontWeight: "500",
      borderRadius: 20,
    },
  },
  backarrow: {
    color: "#b4bcc9",
    fontSize: "20px",
    marginRight: "8px",
  },
  Searchresult: {
    "& h4": {
      fontSize: "16px",
      color: "#0f3d6e",
      fontWeight: "500",
      margin: "40px 0",
      textAlign: "left",
    },
  },
  btncol: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 40,
  },

  Topfilter: {
    width: "100%",
    display: "flex",
    marginTop: 30,
    marginBottom: 50,
    flexDirection: "row",
    "@media only screen and (min-device-width: 768px) and (max-device-width: 1200px)":
      {
        flexWrap: "wrap",
      },
    "& label": { color: "#666", marginBottom: 5, display: "flex" },
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
    "& .MuiInput-input:focus": {
      border: "1px #0074D9 solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
    "& .MuiInputBase-input": {
      height: "50px",
      borderRadius: "10px",
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 15px",
    },
    "& .MuiTextField-root": {
      width: "100%",
    },
  },
  Searchbtn: {
    background: "#0f3d6e",
    borderRadius: 10,
    display: "flex",
    color: "#fff",
    height: 50,
    paddingLeft: 30,
    paddingRight: 30,
    marginLeft: 10,
    textTransform: "capitalize",
    marginTop: 28,
    "@media only screen and (max-width: 820px)": {
      marginLeft: 15,
    },
    "@media only screen and (max-width: 768px)": {
      marginLeft: 15,
    },
    "&:hover": {
      background: "rgba(0,0,0,0.8)",
    },
  },
  Formcol: {
    display: "flex",
    alignItems: "center",

    marginBottom: "10px",
    marginTop: "10px",
    "&>div": {
      width: "100%",
    },
    "& p": {
      fontSize: "18px",
      margin: "0px",
    },
    "& label": {
      flex: "0 0 205px",
      color: "#000",
      fontSize: "15px",
      fontWeight: "400",
    },
    "& .react-dropdown-select-input": {
      width: "100%",
    },
  },
  select: {
    width: "100%",
    border: "none !important",
    borderRadius: "10px !important",
    border: "1px #D5D5D5 solid",
    backgroundColor: "#F9F9F9",
    display: "flex",
    justifyContent: "flex-start",
    textAlign: "left",
    height: "50px",
    fontSize: "14px !important",
    paddingLeft: "15px !important",
    paddingRight: "15px !important",
    // '& .react-dropdown-select-input':{
    //   display:'none'
    // }
  },
  modal: {
    "& .MuiPaper-rounded": {
      borderRadius: "10px !important",
      padding: "20px",
      width: "550px",
      maxWidth: "550px",
    },
  },
  downloadModal: {
    "& .MuiPaper-rounded": {
      borderRadius: "10px !important",
      padding: "20px",
      width: "950px",
      maxWidth: "950px",
    },
  },
  ccmmodal: {
    borderRadius: "10px",
    "& .MuiInput-underline:before": {
      display: "none",
    },
    "& .MuiInput-underline:after": {
      display: "none",
    },
    "& .MuiInput-formControl": {
      height: "50px",
    },
    "& .MuiInput-input:focus": {
      border: "1px #0074D9 solid",
      boxShadow: "2px 2px 10px 1px rgba(0,0,0,0.3)",
    },
    "& .MuiInputBase-input": {
      height: "50px",
      borderRadius: "10px",
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 15px",
    },
    "& .react-date-picker__wrapper": {
      borderRadius: 10,
      border: "1px #D5D5D5 solid",
      backgroundColor: "#F9F9F9",
      padding: "0 10px",
    },
  },
  modalbtn: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: "30px",
    marginLeft: "15px",
    alignItems: "center",
  },
  // leftnav: {
  //   position: "absolute",
  //   top: "15px",
  //   bottom: "15px",
  //   left: "40px",
  //   right: "40px",
  // },
  // Leftcol: {
  //   width: "12%",
  //   padding: "20px 3%",
  //   position: "relative",
  //   minHeight: "800px",
  //   background: "linear-gradient(45deg, #114ebd, #0f3d6e)",
  // },
  Rightcol: {
    width: "78%",
    padding: "20px 2%",
    borderLeft: "1px #F6F6F6 solid",
    "& .MuiAccordionSummary-root": {
      borderBottom: "1px #5f80a9 solid",
      height: "40px",
      color: "#bfc4cb",
      padding: "0px",
      fontFamily: "Poppins",
    },
    "& .MuiAccordion-root:before": {
      display: "none",
    },
    "& .MuiTab-root": {
      minWidth: "33%",
    },
    "& .MuiTab-root:nth-child(6)": {
      minWidth: "30%",
    },
    "& .MuiTab-root:nth-child(7)": {
      minWidth: "30%",
    },
    "& .MuiBox-root": {
      paddingLeft: "0px",
      paddingRight: "0px",
    },
  },

  Throw1: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    color: "#fff",
    borderBottom: "1px rgba(0,0,0,0.1) solid",
    padding: 5,
    background: "linear-gradient(to left, #114ebd, #0f3d6e)",
    fontSize: "14px",
    width: "98%",
  },
  Thcol: {
    width: "8%",
    color: "#fff",
  },
  Thcol2: {
    width: "8%",
    color: "#fff",
  },
  Thcol3: {
    width: "8%",
    color: "#fff",
  },
  Thcol4: {
    width: "8%",
    color: "#fff",
  },

  Thcol5: {
    width: "22%",
    fontSize: 14,
    color: "#696969",
    color: "#fff",
  },
  Thcol6: {
    width: "23%",
    fontSize: 14,
    color: "#fff",
  },

  Thcol8: {
    width: "19%",
    fontSize: 14,
    color: "#fff",
  },
  Thcol9: {
    width: "14%",
    fontSize: 14,
    color: "#696969",
  },
  Thcol10: {
    width: "20%",
    fontSize: 14,
    color: "#696969",
  },
  Thcol11: {
    width: "20%",
    fontSize: 14,
    color: "#fff",
    // display: "flex",
    // justifyContent: "flex-end",
  },

  Thcol7: {
    width: "10%",
  },

  Thcol12: {
    width: "16%",
    fontSize: 14,
    color: "#fff",
    textAlign: "right",
  },
  Thcol13: {
    width: "10%",
  },
  Tdrow: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px #ccc solid",
    padding: "10px 0",
    fontSize: 14,
  },
  Tdrow1: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
    borderBottom: "1px rgba(0,0,0,0.1) solid",
    padding: "10px 0",
    fontSize: 14,
  },
  Tdcol5: {
    width: "21.5%",
    paddingRight: "0.5%",
    wordWrap: "break-word",
    overflow: "auto",
    fontSize: 14,
  },
  closeicon: {
    fontSize: 20,
  },
  closebtn: {
    width: "40px",
    position: "absolute",
    right: "10px",
    height: "40px",
    background: "#fff",
    top: "10px",
    minWidth: "40px",
    "&:hover": {
      background: "#fff",
    },
  },
  Tdcol6: {
    width: "22.5%",
    paddingRight: "0.5%",
    wordWrap: "break-word",
    overflow: "auto",
    fontSize: 14,
  },
  Tdcol7: {
    width: "13.5%",
    paddingRight: "0.5%",
    fontSize: 14,
  },
  Tdcol8: {
    width: "20.5%",
    paddingRight: "0.5%",
    wordWrap: "break-word",
    overflow: "auto",
    fontSize: 14,
  },
  Tdcol9: {
    width: "13.5%",
    paddingRight: "0.5%",
    fontSize: 14,
  },
  Tdcol10: {
    width: "19.5%",
    paddingRight: "0.5%",
    fontSize: 14,
  },
  Tdcol11: {
    width: "19.5%",
    paddingRight: "0.5%",
    fontSize: 14,
    // display: "flex",
    // justifyContent: "flex-end",
  },
  Tdcol12: {
    width: "16%",
    textAlign: "right",
  },
  Modalclose: {
    width: 45,
    height: 45,
    minWidth: 45,
    borderRadius: 50,
    position: "absolute",
    right: 12,
    top: 10,
  },
  Deletebtn: {
    background: "#fff",
    border: "1px #114ebd solid",
    width: "60px",
    height: "30px",
    float: "right",
    color: "#114ebd",
    textTransform: "capitalize",
    borderRadius: "10px",
    fontWeight: "600",
    marginBottom: "10px",
    marginRight: "10px",
    "&:hover": {
      background: "#114ebd",
      color: "#fff",
    },
  },
}));
